module.exports = __webpack_public_path__ + "img/rotate.e662698c.svg";